import React from 'react'
import { Container } from 'react-bootstrap'
import PlansCompareFeatures from '../../../ui/plans/PlansCompareFeatures'
import { SeeMoreButton } from './components/SeeMoreButton'

const PlansSection = ({
    title = "Right pricing for right plan",
    description = "You can choose among 4 plans that suits your needs"
}) => {
    return (
        <div className="plans-section">
            <Container fluid>
                <div className="info-container">
                    <h1 className="title">{title}</h1>
                    <p className="text">{description}</p>
                </div>
                <div className="plans-container container">
                    <PlansCompareFeatures showButtons={false} />
                </div>
                <SeeMoreButton />
            </Container>
        </div>
    )
}

export default PlansSection
